module.exports = __webpack_public_path__ + "static/img/14000391.6ec73e00.png";